import { render, staticRenderFns } from "./I18nView.vue?vue&type=template&id=0deeb89e&"
import script from "./I18nView.vue?vue&type=script&lang=js&"
export * from "./I18nView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports